export * from './AngularJSAdapter';
export * from './ngReact';
export * from './react.injector';
export * from './react.module';
export * from './react.uirouter';
export * from './state.events';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/reactShims/index.ts